import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartRoleFieldPack: FieldPack = {
  id: 'orgchart-role',
  name: 'Position & Job Architecture',
  description: 'Job family, level, employment type for reorg, new team design, and workforce planning',
  version: '1.0.0',
  dependencies: ['orgchart-base'],
  fields: [
    {
      id: 'positionId',
      label: 'Position ID',
      type: FieldType.TEXT,
      tags: ['role'],
      priority: 85,
      namespace: 'role',
      sensitivity: 'internal',
    },
    {
      id: 'positionCode',
      label: 'Position Code',
      type: FieldType.TEXT,
      tags: ['role'],
      priority: 80,
      namespace: 'role',
      sensitivity: 'internal',
    },
    {
      id: 'jobFamily',
      label: 'Job Family',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 75,
      namespace: 'role',
      sensitivity: 'internal',
    },
    {
      id: 'jobLevel',
      label: 'Job Level',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['role'],
      priority: 70,
      namespace: 'role',
      sensitivity: 'internal',
    },
    {
      id: 'managementLevel',
      label: 'Management Level',
      type: FieldType.SELECT,
      tags: ['role'],
      priority: 65,
      namespace: 'role',
      options: [
        { value: 'ic', label: 'Individual Contributor' },
        { value: 'lead', label: 'Lead' },
        { value: 'manager', label: 'Manager' },
        { value: 'senior_manager', label: 'Senior Manager' },
        { value: 'director', label: 'Director' },
        { value: 'vp', label: 'VP' },
        { value: 'svp', label: 'SVP' },
        { value: 'c_level', label: 'C-Level' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'employmentType',
      label: 'Employment Type',
      type: FieldType.SELECT,
      tags: ['role', 'employment'],
      priority: 60,
      namespace: 'role',
      options: [
        { value: 'full_time', label: 'Full-Time' },
        { value: 'part_time', label: 'Part-Time' },
        { value: 'contract', label: 'Contract' },
        { value: 'intern', label: 'Intern' },
        { value: 'temporary', label: 'Temporary' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'fte',
      label: 'FTE',
      type: FieldType.NUMBER,
      tags: ['role', 'employment'],
      priority: 55,
      namespace: 'role',
      min: 0,
      max: 1,
      step: 0.1,
      sensitivity: 'internal',
    },
    {
      id: 'workerType',
      label: 'Worker Type',
      type: FieldType.SELECT,
      tags: ['role', 'employment'],
      priority: 50,
      namespace: 'role',
      options: [
        { value: 'employee', label: 'Employee' },
        { value: 'contractor', label: 'Contractor' },
        { value: 'consultant', label: 'Consultant' },
        { value: 'vendor', label: 'Vendor' },
        { value: 'agency', label: 'Agency' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'regularTemporary',
      label: 'Regular/Temporary',
      type: FieldType.SELECT,
      tags: ['role', 'employment'],
      priority: 45,
      namespace: 'role',
      options: [
        { value: 'regular', label: 'Regular' },
        { value: 'temporary', label: 'Temporary' },
        { value: 'seasonal', label: 'Seasonal' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'flsaStatus',
      label: 'FLSA Status',
      type: FieldType.SELECT,
      tags: ['role', 'compliance'],
      priority: 40,
      namespace: 'role',
      options: [
        { value: 'exempt', label: 'Exempt' },
        { value: 'non_exempt', label: 'Non-Exempt' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'unstaffed',
      label: 'Vacant Position',
      type: FieldType.BOOLEAN,
      tags: ['role'],
      priority: 35,
      namespace: 'role',
      sensitivity: 'internal',
    },
    {
      id: 'isFuture',
      label: 'Future Position',
      type: FieldType.BOOLEAN,
      tags: ['role'],
      priority: 30,
      namespace: 'role',
      sensitivity: 'internal',
    },
  ],
};
